export default __webpack_public_path__ + "static/media/logo_cr38te.b7c19dc1.svg";